<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import MonitorCounters from "@/components/widgets/monitorCounters";

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    MonitorCounters
  },
  data() {
    return {
      title: "Monitoring Dashboard",
      items: [
        {
          text: "Admin",
        },
        {
          text: "Monitoring Dashboard",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <MonitorCounters />

    <div class="row">

    </div>
  </Layout>
</template>